import { Route } from '@angular/router';
import { transactionRoutes } from './transaction/transaction.route';
import { objectManagementRoutes } from './object-management/object-management.route';
import { tariffsRoute } from './tariff';
import { dashboardRoutes } from './dashboard/dashboard.route';
import { settingsRoutes } from './settings';
import { adminGuard, permissionGuard } from '../core';
import { parkingManagementRoutes } from './parking-management/parking-management.route';
import { whitelistsRoutes } from './whitelists/whitelists.route';
import { blacklistRoutes } from './blacklist/blacklist.route';
import { debtsRoutes } from './debts/debts.route';
import { armRoutes } from './arm/arm.route';

export const pagesRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'arm/wall',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./dashboard').then(m => m.DashboardPage),
    title: 'UIMS - Dashboard',
    children: dashboardRoutes,
  },
  {
    path: 'parking-management',
    loadComponent: () => import('./parking-management').then(m => m.ParkingManagementPage),
    title: 'UIMS - Parking Management',
    children: parkingManagementRoutes,
  },
  {
    path: 'transaction',
    loadComponent: () => import('./transaction').then(m => m.TransactionPage),
    title: 'UIMS - Transaction',
    children: transactionRoutes,
  },
  {
    path: 'object-management',
    loadComponent: () => import('./object-management').then(m => m.ObjectManagementPage),
    title: 'UIMS - ObjectManagement',
    children: objectManagementRoutes,
  },
  {
    path: 'tariff',
    loadComponent: () => import('./tariff').then(m => m.TariffPage),
    title: 'UIMS - Tariff',
    children: tariffsRoute,
  },
  {
    path: 'whitelists',
    loadComponent: () => import('./whitelists').then(m => m.WhitelistsPage),
    title: 'UIMS - Whitelists',
    children: whitelistsRoutes,
  },
  {
    path: 'blacklist',
    loadComponent: () => import('./blacklist').then(m => m.BlacklistPage),
    title: 'UIMS - Blacklist',
    children: blacklistRoutes,
  },
  {
    path: 'debts',
    loadComponent: () => import('./debts').then(m => m.DebtsPage),
    title: 'UIMS - Debts',
    children: debtsRoutes,
  },
  {
    path: 'settings',
    loadComponent: () => import('./settings').then(m => m.SettingsPage),
    title: 'UIMS - Settings',
    canActivate: [adminGuard],
    children: settingsRoutes,
  },
  {
    path: 'arm',
    loadComponent: () => import('./arm').then(m => m.ArmPage),
    title: 'UIMS - ARM',
    children: armRoutes,
  },
  {
    path: 'permissions',
    loadComponent: () => import('./permissions').then(m => m.PermissionsPage),
    title: 'UIMS - Permissions',
    canActivate: [permissionGuard('permissions:manage')],
  },
  {
    path: 'not-found',
    loadComponent: () => import('@shared/pages').then(c => c.NotFoundPage),
    pathMatch: 'full',
    title: 'base.notFound',
  },
  {
    path: '**',
    redirectTo: 'not-found',
    pathMatch: 'full',
  },
];
